<template>
  <v-col sm='12'>
    <v-row no-gutters>
      <v-col style="padding: 20px">
        <v-card style="padding: 0 15px 25px 15px;">
          <v-card-header>
            <v-card-icon>
              <i class="fa fas fa-music"></i>
            </v-card-icon>

            <h4 class="title">
              {{ $t("webChannel.SnippetAudio.title") }}
            </h4>
          </v-card-header>
          <v-card-content>
            <form class="form-horizontal" action method="post">
              <div class="v-inputs__select-file">
                <v-layout>
                  <v-select
                    v-model="canalWebData.selectSound"
                    item-text="title"
                    return-object
                    hide-details
                    hide-selected
                    :items="fileTypeItems"
                    :label="$t('webChannel.SnippetAudio.subitems.example')"
                    :no-data-text="$t('webChannel.SnippetAudio.subitems.noFilesFound')"
                    required
                  ></v-select>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="v-btn__play"
                        @click="playSound(canalWebData.selectSound.url)"
                      >
                        <v-icon>mdi-play</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('webChannel.SnippetAudio.subitems.listenToSelectedAudio') }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="v-btn__delete"
                        @click="deleteSound(canalWebData.selectSound)"
                        :disabled="canalWebData.selectSound.isSoundEds"
                      >
                        <v-icon>mdi-trash-can</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('webChannel.SnippetAudio.subitems.deleteInsertedAudio') }}</span>
                  </v-tooltip>
                </v-layout>
              </div>
              <div>
                <label class="input-file">{{ $t("webChannel.SnippetAudio.subitems.uploadaNewAudio") }}</label>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      :class="[
                        'dropZone', dragging ? 'dropZone-over' : ''
                      ]"
                      @dragenter="dragging = true"
                      @dragleave="dragging = false"
                    >
                      <div class="dropZone-info" @drag="dragOnChange">
                        <v-icon>mdi-file-music</v-icon>
                        <div class="dropZone-title">
                          {{ $t("webChannel.SnippetAudio.subitems.dragYourFileHereOrSearch") }}
                          <span>{{ $t("webChannel.SnippetAudio.subitems.search") }}</span>
                        </div>
                        <div class="dropZone-upload-limit-info">
                          <div>
                            {{ $t("webChannel.SnippetAudio.subitems.maxSize", {value: fileMaxLimit/1000}) }} |
                            {{ $t("webChannel.SnippetAudio.subitems.formatType") }} |
                            {{ $t("webChannel.SnippetAudio.subitems.charactersAccepted") }}
                          </div>
                        </div>
                      </div>
                      <input
                        v-bind="attrs"
                        v-on="on"
                        ref="imageUploader"
                        type="file"
                        @change="dragOnChange"
                      >
                    </div>
                  </template>
                  <span>{{ $t("webChannel.SnippetAudio.subitems.insertYourDocumentHere") }}</span>
                </v-tooltip>
              </div>
              <div class="info-new-file" v-if="showContentNewFile">
                <div class="uploadedFile_select-buttons">
                  <div class="uploadedFile-info">
                    <div>
                      <div class="uploadedFile-info__file-name">{{ file.name }}</div>
                      <div class="uploadedFile-info__size-file">{{ file.size }} kb</div>
                    </div>
                    <v-icon @click="removeFileDragAndDrop()">mdi-close</v-icon>
                  </div>
                  <v-btn class="uploadedFile_buttons uploadedFile_buttons-cancel" @click="removeFileDragAndDrop()">
                    {{ $t("webChannel.SnippetAudio.subitems.cancel") }}
                  </v-btn>
                  <v-btn
                    class="uploadedFile_buttons uploadedFile_buttons-send"
                    :disabled="showMessageError"
                    @click="sendNewAlertAudio()"
                  >
                    {{ $t("webChannel.SnippetAudio.subitems.send") }}
                </v-btn>
                </div>
                <span v-if="showMessageError && typeNewFileInvalid" class="uploadedFile-info__alert-message">
                  {{ $t("webChannel.SnippetAudio.subitems.invalidTypeFileErrorMessage") }}
                </span>
                <span v-if="showMessageError && sizeNewFileInvalid" class="uploadedFile-info__alert-message">
                  {{ $t("webChannel.SnippetAudio.subitems.invalidSizeFileErrorMessage") }}
                </span>
                <span v-if="showMessageError && limitSizeNameNewInvalid" class="uploadedFile-info__alert-message">
                  {{ $t("webChannel.SnippetAudio.subitems.invalidNameSizeFileErrorMessage") }}
                </span>
                <span v-if="showMessageError && audioAlreadyExists" class="uploadedFile-info__alert-message">
                  {{ $t("webChannel.SnippetAudio.subitems.audioAlreadyExistsErrorMessage") }}
                </span>
                <span v-if="showMessageSuccess" class="uploadedFile-success-message">
                {{ $t("webChannel.SnippetAudio.subitems.newFileSuccessfullyAdded") }}
                </span>
              </div>
              <span v-if="saveSoundErrorMessage" class="uploadedFile-info__alert-message">
                {{ $t("webChannel.SnippetAudio.subitems.saveSoundErrorMessage") }}
              </span>
              <span v-if="deleteSoundSuccessMessage" class="uploadedFile-success-message">
                {{ $t("webChannel.SnippetAudio.subitems.deleteSoundSuccessMessage") }}
              </span>
            </form>
          </v-card-content>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { mask } from 'vue-the-mask'
import axios from 'axios'
import { mapFields } from 'vuex-map-fields'
import Swal from 'sweetalert2'

export default {
  directives: { mask },
  props: {
    canalWebData: {
      type: Object,
      required: true
    },
    canalWebId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      file: '',
      dragging: false,
      rules: {
        required: value => !!value || this.$t('webChannel.StopWords.subitems.required')
      },
      supportedFileTypes: [
        'audio/mp3',
        'audio/ogg',
        'audio/webm',
        'audio/mpeg',
        'audio/mweb',
        'audio/mepeg'
      ],
      fileMaxLimit: 50000,
      fileLimiteSizeNameAudio: 100,
      getNewSoundAddedObject: '',
      fileTypeItems: [],
      saveSoundVerification: {},
      saveSoundErrorMessage: false,
      showContentNewFile: false,
      showMessageError: false,
      showMessageSuccess: false,
      typeNewFileInvalid: false,
      sizeNewFileInvalid: false,
      limitSizeNameNewInvalid: false,
      audioAlreadyExists: false,
      deleteSoundSuccessMessage: false,
      generalConfigInfo: {},
      updatedListOfSongs: {},
      newAudioExistisInListYet: []
    }
  },
  methods: {
    playSound (sound) {
      if (sound) {
        var audio = new Audio(sound)
        audio.play()
      }
    },

    dragOnChange (e) {
      let files = e.target.files || e.dataTransfer.files
      this.dragging = false
      if (!files.length) {
        this.showContentNewFile = false
      } else {
        this.createFile(files[0])
      }
    },

    createFile (file) {
      this.showContentNewFile = true
      this.$axios.get(`/assistant-configs/${this.assistantId}`)
        .then(response => {
          this.generalConfigInfo = response.data
          this.updatedListOfSongs = this.generalConfigInfo.webclientChannels[0].config.notificationSounds
          this.newAudioExistisInListYet = this.updatedListOfSongs.filter(audio => audio.title.includes(file.name))

          if (
            this.typeNewFileValidation(file) &&
            this.sizeNewFileValidation(file) &&
            this.limitSizeNameNewFileValidation(file) &&
            !this.newAudioExistisInListYet.length
          ) {
            this.showMessageError = false
            this.file = file
          } else {
            this.typeNewFileInvalid = false
            this.sizeNewFileInvalid = false
            this.limitSizeNameNewInvalid = false
            this.audioAlreadyExists = false

            if (!this.typeNewFileValidation(file)) {
              this.typeNewFileInvalid = true
            }
            if (!this.sizeNewFileValidation(file)) {
              this.sizeNewFileInvalid = true
            }
            if (!this.limitSizeNameNewFileValidation(file)) {
              this.limitSizeNameNewInvalid = true
            }
            if (this.newAudioExistisInListYet.length >= 1) {
              this.audioAlreadyExists = true
            }
          }
        })

      this.file = ''
      this.$refs.imageUploader.value = ''
      this.showMessageError = true
    },

    async upload (file, name) {
      try {
        const clientUrl = this.canalWebData.botAvatarUrl.match((/(?<=assistants).*\/(?!=avatar)/g)).pop().replace('webchannels', 'webchannel').replace(/^\//, '').replace(/\/$/, '')
        name = 'audio/' + name
        const result = await this.$axios.post(
          `/assistant-configs/${clientUrl}/upload-link`,
          {
            fileMimeType: file.type,
            name
          }
        )
        const fullmock = result.data
        const form = new FormData()
        const mock = fullmock.preSigned

        Object.entries(mock.fields).forEach(([k, v]) => {
          form.append(k, v)
        })
        form.append('file', file)
        const uploadResponse = await axios.post(mock.url, form)
        if (uploadResponse.status === 204) {
          return `https://${mock.bucket}.s3.us-east-2.amazonaws.com/${mock.filePath}`
        }
      } catch (error) {
        return Promise.reject(error)
      }
    },

    async sendNewAlertAudio () {
      try {
        const uploadedAudioLink = await this.upload(this.file, this.file.name)
        this.showMessageSuccess = true
        let newFile = {
          title: this.file.name,
          type: this.file.type,
          url: uploadedAudioLink
        }
        this.fileTypeItems.push(newFile)

        this.canalWebData.selectSound = newFile
        setTimeout(() => {
          this.showMessageSuccess = false
          this.showContentNewFile = false
        }, 3000)
      } catch (e) {
        Swal.fire({
          icon: 'error',
          title: this.$t('commonWords.genericError')
        })
      } finally {
        this.file = ''
      }
    },

    async deleteSound (file) {
      this.$axios.get(`/assistant-configs/${this.assistantId}`)
        .then(async response => {
          this.generalConfigInfo = response.data
          this.saveSoundVerification = this.generalConfigInfo.webclientChannels[0].config.selectSound
          const name = file.title
          const clientUrl = this.canalWebData.botAvatarUrl.match((/(?<=assistants).*\/(?!=avatar)/g)).pop().replace('webchannels', 'webchannel').replace(/^\//, '').replace(/\/$/, '')
          this.saveSoundErrorMessage = false
          if (name === this.saveSoundVerification.title) {
            this.saveSoundErrorMessage = true
            setTimeout(() => {
              this.saveSoundErrorMessage = false
            }, 3000)
          } else {
            try {
              await this.$axios.delete(
                `/assistant-configs/${clientUrl}/${name}`
              ).then(response => {
                if (response.status === 200) {
                  this.fileTypeItems = this.canalWebData.notificationSounds
                  let indiceSoundToRemove = this.fileTypeItems.findIndex((audio) => {
                    return audio.title === this.canalWebData.selectSound.title
                  })

                  this.fileTypeItems.splice(indiceSoundToRemove, 1)
                  this.canalWebData.selectSound = this.saveSoundVerification
                  this.deleteSoundSuccessMessage = true

                  setTimeout(() => {
                    this.deleteSoundSuccessMessage = false
                  }, 3000)
                }
              })
            } catch (error) {
              Swal.fire({
                icon: 'error',
                title: this.$t('canalWeb.error'),
                html: `${this.$t('canalWeb.couldNotAccessWizardSettings')} <br> ${error}`
              })
            }
          }
        })
    },

    removeFileDragAndDrop () {
      this.showContentNewFile = false
      this.$refs.imageUploader.value = ''
    },

    typeNewFileValidation (file) {
      return file.type.match('audio.*') && this.supportedFileTypes.includes(file.type)
    },

    sizeNewFileValidation (file) {
      return file.size < this.fileMaxLimit
    },

    limitSizeNameNewFileValidation (file) {
      return file.name.length < this.fileLimiteSizeNameAudio
    }

  },
  created () {
    this.fileTypeItems = this.canalWebData.notificationSounds
  },
  computed: {
    extension () {
      return (this.file) ? this.file.name.split('.').pop() : ''
    },
    ...mapFields('selectedAssistant', ['assistantId'])
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .v-card {
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14) !important;
  }

  ::v-deep v-card-header {
    display: flex;
  }

  ::v-deep v-card-icon {
  margin: 0 15px 15px 0;
  border-radius: 3px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
  background: linear-gradient(60deg, #66bb6a, #43a047);
  box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28),
              0 4px  20px 0px   rgba(0, 0, 0, 0.12),
              0 7px  8px  -5px  rgba(76, 175, 80, 0.2);
  padding: 15px;
}

// ::v-deep v-card-icon {
//     margin: 0 15px 15px 0;
//     border-radius: 3px;
//     margin-top: -20px;
//     margin-right: 15px;
//     float:px !important;
//     border-radius: 5px;
//   }

  ::v-deep .fa {
    color: #fff;
    width: 33px;
    height: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ::v-deep .title {
    color: #3c4858;
    margin-top: 15px;
  }

  ::v-deep .layout,
  ::v-deep .v-text-field {
    padding: 15px 15px 15px 10px !important;
  }

/* ===============================
            INPUT SELECT
================================== */
::v-deep .theme--light.v-list-item--active::before,
  ::v-deep .theme--light.v-list-item--active:hover::before,
  ::v-deep .theme--light.v-list-item:focus::before,
  ::v-deep .theme--light.v-list-item--active:focus::before,
  ::v-deep .theme--light.v-list-item.v-list-item--highlighted::before {
    background-color: #FFF !important;
  }

  ::v-deep .v-select__selection.v-select__selection--comma {
    padding-left: 10px;
  }

  ::v-deep.v-list-item__title {
    content: 'default';
  }

  ::v-deep .v-list-item:hover {
    background-color: #9031AA;
    color:#FFF !important;
    box-shadow: 0px 1px 5px #9031AA;
    border-radius: 5px;
  }

  .layout.v-layout__inputs {
    flex-direction: column;
    padding: 0 15px;
  }

  .v-input.v-input_inputs {
    align-items: flex-start;
  }

  ::v-deep.v-text-field {
    margin-top: 0px !important;
  }

  ::v-deep.v-text-field .v-label--active {
    transform:
      translateY(-30px)
      translateX(-18px)scale(.75) !important;
  }

  .v-menu__content.theme--light.menuable__content__active {
    border-radius: 5px;
  }

  .v-list-item::after {
    color: #181818;
  }

  .v-input__icon.v-input__icon--append {
    padding-right: 15px;
  }

  .v-btn.v-btn__play,
  .v-btn.v-btn__delete {
    height: 40px !important;
    min-width: 0px !important;
    width: 40px !important;
  }

  .v-btn.v-btn--disabled {
    background-color: #A8A8A8 !important;
  }

  .v-btn.v-btn__play {
    margin: 0.75rem 0px 5px;
  }

  .v-btn.v-btn__delete {
    margin: 0.75rem 0px 5px 15px;
  }

  .v-btn > .v-btn__content .v-icon {
    color: #FFF !important;
  }

  .v-layout__inputFile {
    width: 100%;
    height: 25%;
    max-height: 122px;
    border: 1px dotted #A8A8A8;
  }

/* ===============================
          DRAG AND DROP
================================== */
  .v-label.theme--light {
    padding-left: 10px;
  }

  .v-label.v-label--active.theme--light.primary--text,
  .v-label.v-label--active.theme--light {
    padding-left: 0px;
  }

  .snippet-audio__input-select > .v-input__control {
    background-color: rgba(249, 248, 248, 1);
    border-radius: 5px 5px 0px 0px !important;
  }

  .dropZone {
    display: flex;
    justify-content: center;
    margin: 10px auto;
    border-radius: 5px;
    width: calc(100% - 30px);
    height: 125px;
    position: relative;
    border: 1px dashed #A8A8A8;
    background-color: rgba(249, 248, 248, 1);
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .dropZone-info v-icon {
    font-size: 40px;
  }

  .dropZone-title {
    color: #787878;
  }

  .dropZone-title span {
    font-weight: 900;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: #F9F8F8;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    font-size: 10px;
  }

  .dropZone-over {
    background-color: rgba(144, 49, 170, 0.39);
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  label.input-file {
    padding-left: 15px;
    color: rgba(0,0,0,.6);
    line-height: 20px;
    letter-spacing: normal;
    font-size: 12px;
  }

  .uploadedFile_select-buttons {
    display: flex;
    padding-right: 15px;
    align-items: center;
    justify-content: space-between;
  }

  .uploadedFile-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid rgba(168, 168, 168, 1);
    padding: 8px 20px;
    background-color: rgba(249, 248, 248, 1);
    margin: .5rem 1rem;
    border-radius: 5px;
    width: 100%;
  }

  .uploadedFile-info v-icon {
    cursor: pointer;
  }

  .uploadedFile-info__file-name {
    font-size: 14px;
    color: #000;
    line-height: 16.94px;
  }

  .uploadedFile-info__size-file {
    font-size: 10px;
    color: rgba(168, 168, 168, 1);
    line-height: 12.1px;
  }

  .uploadedFile-info__close-file {
    font-size: 14px;
    color: rgba(168, 168, 168, 1);
  }

  .uploadedFile_buttons {
    font: 400 0.875rem Inter, sans-serif;
    line-height: 12px;
    color: rgba(255, 255, 255, 1) !important;
  }

  .uploadedFile_buttons.uploadedFile_buttons-cancel {
    margin-right: 10px;
  }

  .uploadedFile_select-buttons .v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 64px;
    padding: 0 16px;
  }

  .v-btn__play,
  .v-btn__delete,
  .uploadedFile_buttons-send {
    background-color: #2E4F8B !important;
  }

  .uploadedFile-info__alert-message {
    font-size: 12px;
    color: #E44C37;
    font-style: italic;
    padding-left: 16px;
  }

  .uploadedFile-success-message {
    color: #43a047;
    padding-left: 16px;
    font-style: italic;
  }

  .uploadedFile_buttons-send {
    padding: 15px;
  }

  .uploadedFile_buttons-cancel {
    background-color: rgba(168, 168, 168, 1) !important;
  }
</style>
